import { __assign, __awaiter, __generator } from "tslib";
import { HttpRequest } from "@aws-sdk/protocol-http";
var CONTENT_LENGTH_HEADER = "content-length";
export function contentLengthMiddleware(bodyLengthChecker) {
  var _this = this;

  return function (next) {
    return function (args) {
      return __awaiter(_this, void 0, void 0, function () {
        var request, body, headers, length;

        var _a;

        return __generator(this, function (_b) {
          request = args.request;

          if (HttpRequest.isInstance(request)) {
            body = request.body, headers = request.headers;

            if (body && Object.keys(headers).map(function (str) {
              return str.toLowerCase();
            }).indexOf(CONTENT_LENGTH_HEADER) === -1) {
              length = bodyLengthChecker(body);

              if (length !== undefined) {
                request.headers = __assign(__assign({}, request.headers), (_a = {}, _a[CONTENT_LENGTH_HEADER] = String(length), _a));
              }
            }
          }

          return [2
          /*return*/
          , next(__assign(__assign({}, args), {
            request: request
          }))];
        });
      });
    };
  };
}
export var contentLengthMiddlewareOptions = {
  step: "build",
  tags: ["SET_CONTENT_LENGTH", "CONTENT_LENGTH"],
  name: "contentLengthMiddleware",
  override: true
};
export var getContentLengthPlugin = function getContentLengthPlugin(options) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.add(contentLengthMiddleware(options.bodyLengthChecker), contentLengthMiddlewareOptions);
    }
  };
};